import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.289 2.27a1 1 0 0 0-.684-.27H6a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V9.933a1 1 0 0 0-.316-.73z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", { d: "M19 2v8h8M21 17H11M21 23H11" }, null, -1)
  ]))]))
}
export default { render: render }